export enum RelatedPersonRelationship {
  NextOfKin = 'relatedperson.relationship.nextofkin',
  CoverageSubscriber = 'relatedperson.relationship.coverage.subscriber',
}
